import smart from 'address-smart-parse';
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  created() {
    this.SysType = localStorage.getItem("sys_type");
  },
  data() {
    return {
      mallId: "",
      printData: null,
      identification: "",
    }
  },
  methods: {
    setToken(mallId) {
      this.mallId = mallId;
    },
    onOpened() {
      console.log("onOpened");
      this.printData = null;
    },
    getAddressCodeByName(name) {
      console.log("name", name);
      const info = smart(name);
      console.log(info);
      return info.provinceCode + "/" + info.cityCode + "/" + info.countyCode;
    },
    saveDataFunc() {
      return this.onSave();
    },
    saveAndPrint() {
      this.$refs.dialog.formValidate().then(valid => {
        if (!valid) return;
        this.onSave().then(res => {
          if (res.Code == 0) {
            this.$message.success("保存成功");
            this.printData = this.data.id;
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        })
      })
    },
    saveAndCreate() {
      this.$refs.dialog.formValidate().then(valid => {
        if (!valid) return;
        this.onSave().then(res => {
          if (res.Code == 0) {
            this.$message.success("保存成功");
            this.$emit('close-saved');
          } else {
            this.$message.error(res.Msg);
          }
        })
      })
    },
    onClosed() {
      this.identification = "";
      if (this.printData) {
        this.$emit("show-print", this.printData)
      }
      this.onReset();
    },
    onReset() {
      this.$refs.dialog.isSaved = false;
      this.$refs.dialog.isChange = false;
      this.$refs.dialog.isEdit = false;
      var initData = this.$platformJs.getPddObj('freeprint.editDialog');
      this.$refs.dialog.setData(initData);
      this.$refs.dialog.clearValidate();
    }
  }
}